import $ from "jquery";

export default {
  formatNumbers(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  },
  export(data, fileName) {
    let json = data;
    let fields = Object.keys(json[0]);
    let replacer = function(key, value) {
      return value === null ? "" : value;
    };
    let csv = json.map(function(row) {
      return fields
        .map(function(fieldName) {
          return JSON.stringify(row[fieldName], replacer);
        })
        .join(";");
    });
    csv.unshift(fields.join(";")); // add header column
    csv = csv.join("\r\n");
    let BOM = "\uFEFF";
    csv = BOM + csv;
    csv = "data:text/csv;charset=utf-8," + csv;

    let encodedUri = encodeURI(csv);
    let link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", fileName);
    document.body.appendChild(link); // Required for FF
    link.click();
  },
};
